module.exports = __webpack_public_path__ + "img/10551391_L.3681e6df.png";